import { render } from "./ParametrosGlobales.vue?vue&type=template&id=147cb98f"
import script from "./ParametrosGlobales.vue?vue&type=script&lang=js"
export * from "./ParametrosGlobales.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__